// Pantalla que se muestra cuando licencia_activa = false en la DB

const SOPORTE = {
  nombre:   'Walter Neira',
  telefono: '+54 11 5486-7460',
  email:    'ivanneira2015@gmail.com',
  whatsapp: '5491154867460',
}

export default function SuspendidoScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--me-bg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--me-space-8)',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 460,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--me-space-6)',
      }}>
        {/* Logo mark */}
        <div style={{
          width: 52,
          height: 52,
          background: 'var(--me-surface-3)',
          borderRadius: 14,
          clipPath: 'polygon(0 0, 100% 0, 100% 75%, 75% 100%, 0 100%)',
        }} />

        {/* Card */}
        <div className="me-card" style={{ width: '100%', padding: 'var(--me-space-8)', textAlign: 'center' }}>
          {/* Icono alerta */}
          <div style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: 'var(--me-warn-soft)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto var(--me-space-5)',
          }}>
            <svg viewBox="0 0 24 24" width={24} height={24} fill="none"
              stroke="var(--me-warn)" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>

          <div className="me-eyebrow" style={{ marginBottom: 'var(--me-space-2)' }}>MayoExpress</div>
          <h1 className="me-page-title" style={{ marginBottom: 'var(--me-space-3)', fontSize: 22 }}>
            Servicio suspendido
          </h1>
          <p style={{
            fontSize: 14,
            color: 'var(--me-text-3)',
            lineHeight: 1.6,
            marginBottom: 'var(--me-space-6)',
          }}>
            El acceso al sistema está temporalmente suspendido.<br />
            Contactate con el soporte para regularizar el servicio.
          </p>

          {/* Separador */}
          <div style={{ height: 1, background: 'var(--me-line-2)', marginBottom: 'var(--me-space-6)' }} />

          {/* Contacto */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--me-space-3)' }}>

            {/* WhatsApp */}
            <a
              href={`https://wa.me/${SOPORTE.whatsapp}?text=Hola%20Walter%2C%20necesito%20reactivar%20mi%20servicio%20MayoExpress`}
              target="_blank"
              rel="noopener noreferrer"
              className="me-btn me-btn-primary"
              style={{ width: '100%', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            >
              <svg viewBox="0 0 24 24" width={16} height={16} fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Escribir por WhatsApp
            </a>

            {/* Teléfono */}
            <a
              href={`tel:${SOPORTE.telefono.replace(/\s/g, '')}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                padding: '10px 0',
                borderRadius: 8,
                border: '1.5px solid var(--me-line)',
                color: 'var(--me-text-2)',
                textDecoration: 'none',
                fontFamily: 'var(--me-sans)',
                fontSize: 13.5,
                fontWeight: 500,
                transition: 'background var(--me-dur-short)',
              }}
            >
              <svg viewBox="0 0 24 24" width={15} height={15} fill="none"
                stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
              {SOPORTE.telefono}
            </a>

            {/* Email */}
            <a
              href={`mailto:${SOPORTE.email}?subject=Reactivacion%20MayoExpress`}
              style={{
                fontSize: 13,
                color: 'var(--me-text-4)',
                textAlign: 'center',
                textDecoration: 'none',
              }}
            >
              {SOPORTE.email}
            </a>
          </div>
        </div>

        <p style={{ fontSize: 12, color: 'var(--me-text-4)', textAlign: 'center' }}>
          {SOPORTE.nombre} · Soporte MayoExpress
        </p>
      </div>
    </div>
  )
}
